<template>
  <hm-content title="会员记录">
    <el-tabs v-model="record" @tab-click="handleClick">
      <el-tab-pane label="购买记录" name="0">
        <ul class="record-list">
          <li class="item" v-for="(v, i) in purchaseHistory" :key="i">
            <div class="item-header flex flex-between">
              <div>
                <span class="title">订单：</span>
                {{ v.orderId }}
              </div>
              <div class="time">
                <span class="title">购买时间：</span>
                {{ v.addTimeFormat }}
              </div>
            </div>
            <div class="item-body flex item-center">
              <span class="title">商品：</span>
              <ul class="product-list">
                <li
                  class="flex flex-between"
                  v-for="(item, index) in v.productRecord"
                  :key="index"
                >
                  <span>{{ item.productName }} x {{ item.productNum }}</span>
                  <strong>￥{{ item.price }}</strong>
                </li>
              </ul>
            </div>
            <div class="item-body flex item-center" v-show="v.cardList.length">
              <span class="title">服务卡：</span>
              <ul class="product-list">
                <li
                  class="flex flex-between"
                  v-for="(item, index) in v.cardList"
                  :key="index"
                >
                  <span>{{ item.productName }} - {{ item.useTimes }} 次</span>
                  <strong>￥{{ item.relatedPrice }}</strong>
                </li>
              </ul>
            </div>
            <div class="item-body flex item-center" v-show="v.couponMap">
              <span class="title">优惠券：</span>
              <ul class="product-list">
                <li class="flex flex-between">
                  <span>{{ v.couponMap ? v.couponMap.couponName : "" }}</span>
                  <strong
                    >-￥{{
                      v.couponMap ? v.couponMap.couponCutMoney : ""
                    }}</strong
                  >
                </li>
              </ul>
            </div>
            <div class="item-footer">
              <div class="total">
                <span class="title">合计：</span>
                ￥{{ v.payPrice }}
              </div>
            </div>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="预约记录" name="1">
        <ul class="record-list appoint-list">
          <li class="item" v-for="(v, i) in appointmentRecord" :key="i">
            <div class="item-header">
              <span class="title">预约时间：</span>
              {{ v.startDateFormat }}
            </div>
            <div class="item-body">
              <div class="flex flex-between">
                <div class="mr10">
                  <span class="title">预约门店：</span>
                  {{ v.storeOutlet }}
                </div>
                <div>
                  <span class="title">服务名称：</span>
                  {{ v.serverName }}
                </div>
              </div>
              <div class="flex flex-between">
                <div>
                  <span class="title">预约技师：</span>
                  {{ v.serverGuider }}
                </div>
                <div :class="{ isCancle: v.status === 3 }">
                  <span class="title">预约状态：</span>
                  {{ v.statusFormat }}
                </div>
              </div>
              <div class="flex flex-between">
                <div class="mr10">
                  <span class="title">会员姓名：</span>
                  {{ v.realName }}
                </div>
                <div>
                  <span class="title">联系电话：</span>
                  {{ v.mobilePhone }}
                </div>
              </div>
              <div>
                <span class="title">备注：</span>
                {{ v.description }}
              </div>
            </div>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="结算记录" name="2">
        <ul class="record-list appoint-list">
          <li class="item" v-for="(v, i) in writeOffRecord" :key="i">
            <div class="item-header">
              <span class="title">结算时间：</span>
              {{ v.checkDateFormat }}
            </div>
            <div class="item-body">
              <div class="flex flex-between">
                <div class="mr10">
                  <span class="title">结算门店：</span>
                  {{ v.storeOutlet }}
                </div>
                <div>
                  <span class="title">结算技师：</span>
                  {{ v.guiderName }}
                </div>
              </div>
              <div>
                <span class="title">结算服务：</span>
                {{ v.serverGuider }}
              </div>
              <div class="flex flex-between">
                <div class="mr10">
                  <span class="title">会员姓名：</span>
                  {{ v.realName }}
                </div>
                <div>
                  <span class="title">联系电话：</span>
                  {{ v.mobilePhone }}
                </div>
              </div>
              <div class="flex item-center">
                <span class="title">服务内容：</span>
                <ul class="product-list">
                  <li
                    class="flex flex-between"
                    v-for="(item, index) in v.productList"
                    :key="index"
                  >
                    <span>{{ item.productName }} x {{ item.pageNo }}</span>
                    <strong>￥{{ item.price }}</strong>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="用卡记录" name="3">
        <ul class="record-list appoint-list">
          <li class="item" v-for="(v, i) in recordWithCard" :key="i">
            <div class="item-header">
              <span class="title">卡名：</span>
              {{ v.productName }}
            </div>
            <div class="item-body">
              <div>
                <span class="title">状态：</span>
                {{ v.useStatusFormat }}
              </div>
              <div v-show="v.useStatus !== 0">
                <span class="title">使用时间：</span>
                {{ v.useTimeFormat }}
              </div>
              <div v-if="v.cardType === 0">
                <span class="title">剩余时间：</span>
                {{ v.remanentTime }}小时
              </div>
              <div v-else>
                <span class="title">剩余次数：</span>
                {{ v.remanentTime }}次
              </div>
            </div>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      record: "0",
      id: ""
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.$store.dispatch("queryPurchaseHistory", { id: this.id });
  },
  computed: mapGetters([
    "purchaseHistory",
    "appointmentRecord",
    "writeOffRecord",
    "recordWithCard"
  ]),
  methods: {
    handleClick() {
      switch (this.record) {
        case "0":
          this.$store.dispatch("queryPurchaseHistory", { id: this.id });
          break;
        case "1":
          this.$store.dispatch("queryAppointmentRecord", { memberId: this.id });
          break;
        case "2":
          this.$store.dispatch("queryWriteOffRecord", { id: this.id });
          break;
        case "3":
          this.$store.dispatch("queryRecordWithCard", { id: this.id });
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  color: #999;
}
.item {
  margin-bottom: 20px;
}
.record-list {
  width: 500px;
  font-size: 14px;

  .item-header {
    padding: 12px;
    border: 1px solid #ebeef5;
  }
  .item-body {
    padding: 12px;
    border-bottom: 1px solid #ebebf5;
    border-left: 1px solid #ebebf5;
    border-right: 1px solid #ebebf5;
    .product-list {
      flex: 1;
      strong {
        color: #ff0000;
        font-weight: normal;
      }
      li {
        line-height: 28px;
      }
    }
  }
  .item-footer {
    padding: 12px;
    border-bottom: 1px solid #ebebf5;
    border-left: 1px solid #ebebf5;
    border-right: 1px solid #ebebf5;
    text-align: right;
    .total {
      color: #ff0000;
    }
  }
}
.appoint-list {
  width: 500px;
  .item-body {
    line-height: 30px;
  }
}

.isCancle {
  color: #ff0000;
}
</style>
